import { Exclude, Expose, Type } from 'class-transformer';
import { FrontFaceId } from '../../core/FrontFaceId';
import { DrawCabinetFrontElement } from './FrontElement/DrawCabinetFrontElement';
import { DrawCabinetFrontElementGroup } from './FrontElement/DrawCabinetFrontElementGroup';
import { DrawFrontDoor } from './FrontElement/DrawFrontDoor';
import { DrawFrontDrawer } from './FrontElement/DrawFrontDrawer';
import { DrawFrontEmpty } from './FrontElement/DrawFrontEmpty';
import { DrawFrontFrame } from './FrontElement/DrawFrontFrame';
import { DrawFrontHorizontalGroove } from './FrontElement/DrawFrontHorizontalGroove';
import { DrawFrontPanel } from './FrontElement/DrawFrontPanel';
import { DrawFrontPullOut } from './FrontElement/DrawFrontPullOut';
import { DrawFrontShutter } from './FrontElement/DrawFrontShutter';

export class DrawCabinetFront {
    @Type(() => FrontFaceId)
    Faces!: FrontFaceId[];

    @Type(() => DrawCabinetFrontElement, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: 'TypeName',
            subTypes: [
                { value: DrawCabinetFrontElement, name: 'DrawCabinetFrontElement' },
                { value: DrawCabinetFrontElementGroup, name: 'DrawCabinetFrontElementGroup' },
                { value: DrawFrontDoor, name: 'DrawFrontDoor' },
                { value: DrawFrontDrawer, name: 'DrawFrontDrawer' },
                { value: DrawFrontEmpty, name: 'DrawFrontEmpty' },
                { value: DrawFrontFrame, name: 'DrawFrontFrame' },
                { value: DrawFrontHorizontalGroove, name: 'DrawFrontHorizontalGroove' },
                { value: DrawFrontPanel, name: 'DrawFrontPanel' },
                { value: DrawFrontPullOut, name: 'DrawFrontPullOut' },
                { value: DrawFrontShutter, name: 'DrawFrontShutter' },
            ],
        },
    })
    Element!: DrawCabinetFrontElement;
}
